import {Redirect, Route, Switch} from 'react-router-dom';
import DonationAlreadyCompleted from './views/DonationAlreadyCompleted';
import Step1 from './views/Step1';
import Product1 from './views/Product1';
import Step2 from './views/Step2';
import InvalidFlow from './views/InvalidFlow';
import Step3 from './views/Step3';
import Step4 from './views/Step4';
import GoogleAnalyticsWrapper from './views/GoogleAnalyticsWrapper';
import React, {useState, useEffect} from 'react';
import Wizard from './Wizard';
import {connect} from 'react-redux';

function DonationRoutes ({formContext}) {
  const searchParams = new URLSearchParams(window.location.search);
  const dm_box = searchParams.get('dm_box');
  const dm_boxQR = searchParams.get('dm_boxQR');
  const [dmBoxInfo, setDmBoxInfo] = useState();
  const dm_inf = searchParams.get('dm_inf');
  const dm_team = searchParams.get('dm_team');
  const [dmInfInfo, setDmInfInfo] = useState();
  const [dmTeamInfo, setDmTeamInfo] = useState();
  const [collectorInfo, setCollectorInfo] = useState();

  useEffect(() => {
    if ((!dm_box && !dm_boxQR) || !formContext.isDonationBox) {
      setDmBoxInfo(false);
      return;
    }

    const controller = new AbortController();
    const signal = controller.signal;

    fetch(`/api/donationBox${dm_box ? `/${dm_box}` : `/QR/${dm_boxQR}`}`,
      {
        signal
      })
      .then(resp => resp.json())
      .then(resp => {
        if (resp) {
          setDmBoxInfo(resp);
        } else {
          setDmBoxInfo(false);
        }
      });

    return () => {
      controller.abort();
    };
  }, [dm_box, dm_boxQR]);

  useEffect(() => {
    if (!dm_inf && !dm_team) {
      setDmInfInfo(false);
      setDmTeamInfo(false);
      return;
    }

    const infController = new AbortController();
    const infSignal = infController.signal;
    const teamController = new AbortController();
    const teamSignal = teamController.signal;

    fetch(`/api/collectingTeams/${dm_team}`,
      {
        signal: teamSignal
      })
      .then(resp => resp.json())
      .then(status => {
        if (status.status) {
          setDmTeamInfo(status.status);
        } else {
          setDmTeamInfo(false);
        }
      });

    fetch(`/api/collectors/${dm_inf}`,
      {
        signal: infSignal
      })
      .then(resp => resp.json())
      .then(status => {
        if (status.status) {
          setDmInfInfo(status.status);
        } else {
          setDmInfInfo(false);
        }
      });


    return () => {
      infController.abort();
      teamController.abort();
    };
  }, [dm_inf, dm_team]);

  useEffect(() => {
    if (dmTeamInfo) {
      return setCollectorInfo({
        totalRevenue_m: dmTeamInfo.totalRevenue_m,
        onlineCollectorTargetRevenue_m: dmTeamInfo.collectingTeamTargetRevenue_m,
        onlineCollectorName: dmTeamInfo.name,
        profileImagePublicUrl: dmTeamInfo.collectingTeamImagePublicUrl,
        onlineCollectorMotivation_txt: dmTeamInfo.collectingTeamMotivation_txt,
        percentageTarget: dmTeamInfo.percentageTarget
      });
    }
    return setCollectorInfo(dmInfInfo);
  }, [dmInfInfo, dmTeamInfo]);

  return (
    <Switch>
      <Route
        path='/'
        exact>
        <Wizard render={({isDonationCompleted, isProductForm}) => (
          isDonationCompleted ? <DonationAlreadyCompleted dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} /> : isProductForm ?
            <Product1 next='/doneren' progressBar='1' /> : <Step1 next='/doneren' progressBar='1' dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} />
        )} />
      </Route>
      <Route
        path='/doneren'>
        <Wizard render={({isDonationCompleted, isStep1Completed}) => (
          isDonationCompleted ? <DonationAlreadyCompleted dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} /> : isStep1Completed ?
            <Step2 next='/betalen' previous='/' progressBar='2' dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} /> : <InvalidFlow dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} />
        )}
        />
      </Route>
      <Route
        path='/betalen'>
        <Wizard render={({isDonationCompleted, isStep2Completed}) => (
          isDonationCompleted ? <DonationAlreadyCompleted dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} /> : isStep2Completed ?
            <Step3 previous='/doneren' progressBar='3' dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} /> : <InvalidFlow dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} />
        )} />
      </Route>
      <Route
        path='/bedankt'>
        <Wizard render={({isStep3Completed}) => (
          isStep3Completed ? <Step4 dmBoxInfo={dmBoxInfo} collectorInfo={collectorInfo} progressBar='4' /> : <GoogleAnalyticsWrapper />
        )} />
      </Route>
      <Redirect to='/' />
    </Switch>
  );
}

export default connect(state => {
  return {
    formContext: state.reducer.formContext
  };
})(DonationRoutes);
